import Layout from "../components/Layout/Layout";

// src/pages/Unauthorized.jsx
const Unauthorized = () => (
  <Layout>
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center p-10 bg-white rounded-lg shadow-lg">
        <h1 className="text-6xl font-bold text-red-600">403</h1>
        <p className="text-2xl mt-4">Access Denied</p>
        <p className="text-gray-600 mt-2">
          You don't have permission to view this page.
        </p>
        <a
          href="/"
          className="mt-6 inline-block px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Go to Dashboard
        </a>
      </div>
    </div>
  </Layout>
);

export default Unauthorized;
